import { Component } from '@angular/core';
import { EngagementComponent } from './engagement.component';

@Component({
  selector: 'eid-engagement-mobile',
  templateUrl: './engagement.mobile.component.html',
  styleUrls: ['./engagement.mobile.component.scss']
})
export class EngagementMobileComponent extends EngagementComponent {}
